export default "__VITE_ASSET__AYvfK3Vd__"